module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Dedication",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v("Dedicated to the living and loving memory of")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("Richard Ottens,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("Friend, educator, and gourmet extraordinaire. We miss you.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("“All things considered, we would rather be dining at The Arches … with you.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-110fbb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled21.vue
// module id = 72
// module chunks = 0